(function () {
    'use strict';

    a3_pilot_reports.controller('ReportsHistoryCtrl', ReportsHistoryCtrl);


    function ReportsHistoryCtrl($scope, $routeParams, $timeout, ReportsHistoryFactory, FlightFactory) {
        var reportId = $routeParams.reportId;
        var flightId = $routeParams.flightId;
        var reportType = $routeParams.reportType;
        var flight = FlightFactory.getFlightFromStorage(flightId);

        window.addEventListener('online', function (e) { $timeout(checkConnectionStatus()); });

        $scope.reports = [];
        $scope.flight = flight;
        $scope.contentToShow = "loading";
        $scope.errorMessage = "";
        $scope.showImage = showImage;
        $scope.imageData = "";
        $scope.closeImage=closeImage;

        $scope.init = function () {
            checkConnectionStatus();
        }
        $scope.init();

        /**
         * Fetches the reports
         * @memberof ReportsHistoryCtrl  
         */
        function fetchReports() {
            ReportsHistoryFactory.getReportsHistory(reportId,reportType)
                .then(response => handleResponse(response))
                .catch(function () { showError("We could not get any reports!"); });
        }

        /**
         * Displays the error message
         * @memberof ReportsHistoryCtrl  
          * @param {string} message message to display
         */
        function showError(message) {
            $scope.contentToShow = "error";
            $scope.errorMessage = message;
        }

        /**
         * Checks if the client is online or offline 
         * if is online fetches the reports else displays relative message
         * @memberof ReportsHistoryCtrl  
         */
        function checkConnectionStatus() {
            var isOnline = window.navigator.onLine;
            if (isOnline) {
                fetchReports()
            }
            else {
                showError("Please check the internet connection!");
            }
        }

        /**
         * Handles the response from the API 
         * if is success displays the reports else shows the error message.
         * @memberof ReportsHistoryCtrl  
         * @param {object} response the response object from API
         */
        function handleResponse(response) {
            if (response.data.success) {
                if (response.data.data.length > 0) {
                    $scope.contentToShow = "reports";
                    $scope.reports = response.data.data;
                }
                else {
                    showError("There are no reports for this flight!");
                }
            }
            else {
                showError("We could not get any reports!");
            }
        }

        /**
         * Displays the image in bootbox dialog box
         * @memberof ReportsHistoryCtrl  
         * @param {object} ImageData The
         */
        function showImage(ImageData) {
            $scope.contentToShow = "image";
            $scope.imageData = ImageData;
        }
        
        /**
         * The function that closes the image and displays the reports again
         * @memberof ReportsHistoryCtrl  
         */
        function closeImage(){
            $scope.contentToShow = "reports";
        }
    }
})();